import rootReducer from "./redux/reducers/rootReducers";
import { createStore } from "redux"
const webWindow: any = window;
const AppStore = createStore(rootReducer, webWindow.__REDUX_DEVTOOLS_EXTENSION__ && webWindow.__REDUX_DEVTOOLS_EXTENSION__())

export default AppStore;